import * as storage from '../utilities/storage';
import { CURRENT_USER } from '../constants/storage';

import {
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  getIdToken,
} from 'firebase/auth';

import config from '../config';
import http from '../utilities/http';
import * as tokenService from './token';
import { clearSnapshot } from './snapshot';
import { auth, provider } from './firebaseAuth';
import Agent from '../store/agent';
import firebaseErrorHandler from '../utilities/firebaseErrorHandler';

export const signIn = async (values) => {
  try {
    const resp = await login(values);

    if (resp.user) {
      const tokens = resp.user.stsTokenManager;
      // Call apiGetUserHFM with email address and access token to get user information
      const { accessToken } = tokens;
      const data = {
        google_token: accessToken,
      };
      const response = await apiGetUserHFM(data);
      if (response.status !== 200) {
        return {
          status: 'failed',
          message: 'Something went wrong!',
        };
      }

      const { role, account_type } = response.data.data.user;

      if (account_type ===  "standard"){
        return {
          status: 'failed',
          message: 'User not authorized to access this system.',
        };
      }

      tokenService.setAccessToken(response.data.data.access_token);
      setCurrentUser({ ...response.data?.data?.user, role, account_type });

      return {
        status: true,
        message: 'login success',
      };
    }
  } catch (errors) {
    return firebaseErrorHandler(errors);
  }
};

/**
 * Login with Google using email and password.
 *
 * @param {{email, password}} payload
 */
export async function login({ email, password }) {
  return signInWithEmailAndPassword(auth, email, password);
}

/**
 * Signup with Google using email and password.
 *
 * @param {{email, password}} payload
 */
export async function signup({ email, password }) {
  createUserWithEmailAndPassword(auth, email, password).catch((error) => {
    console.log(error);
  });
}

/**
 * Login with google.
 */
export async function loginWithGoogle() {
  return signInWithPopup(auth, provider);
}

export const signInWithGoogle = async () => {
  try {
    const resp = await loginWithGoogle();
    if (resp.user) {
      const tokens = resp.user.stsTokenManager;
      const { accessToken } = tokens;
      const data = {
        google_token: accessToken,
      };
      const response = await apiGetUserHFM(data);

      if (response.status !== 200) {
        return {
          status: 'failed',
          message: 'Something went wrong!',
        };
      }

      const { role, account_type } = response.data.data.user;

      tokenService.setAccessToken(response.data.data.access_token);
      setCurrentUser({ ...response.data?.data?.user, role, account_type });

      return {
        status: true,
        message: 'login success',
      };
    }
  } catch (errors) {
    return firebaseErrorHandler(errors);
  }
};

/**
 * Log out of the system.
 */
export async function logout() {
  signOut(auth)
    .then(() => {
      tokenService.clear();
      clearSnapshot();
      storage.clear()
    })
    .catch((error) => {
      console.log(error);
    });
}

/**
 * Refresh access token.
 *
 * @returns {string}
 */
export async function refresh() {
  let access_token = await getIdToken(auth, true);
  tokenService.setAccessToken(access_token);
}

/**
 * Refresh access token.
 *
 * @param {string} token
 * @returns {string}
 */
export async function verifyToken(token) {
  console.log(config.apiUrl + config.endpoints.auth.verify);
  return await http.get(config.apiUrl + config.endpoints.auth.verify, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function setCurrentUser(user) {
  const { email, localId, lastLoginAt, lastRefreshAt, role, account_type , _id } = user;
  storage.set(CURRENT_USER, { id: _id ,email, localId, lastLoginAt, lastRefreshAt, role, account_type });
}

/**
 * Get access token from storage.
 *
 * @returns {string}
 */
export function getCurrentUser() {
  return storage.get(CURRENT_USER);
}

/**
 *
 * @param {*} data
 * @returns
 */
export async function apiResetPassword(data) {
  return Agent.Auth.changePassword(data);
}

/**
 *
 * @param {*} data
 * @returns
 */
export async function apiForgotPassword(data) {
  return Agent.Auth.forgotPassword(data);
}

export async function apiUserMetaMask(data) {
  return Agent.Auth.updateUser(data);
}

export async function apiMetaMaskNonce(data) {
  return Agent.Auth.nonceMetaMask(data);
}

export async function apiSignInMetaMask(data) {
  const response = await Agent.Auth.authMetaMask(data);
  const { account_type } = response.data.data.user;

  if (account_type ===  "standard"){
    return {
      status: 'failed',
      message: 'User not authorized to access this system',
    };
  }

  return response;
}

export async function apiGetUserHFM(data) {
  return Agent.Auth.getGoogleToken(data);
}
